import { render, staticRenderFns } from "./AddTipocontratoPage.vue?vue&type=template&id=662fd8d8"
import script from "./AddTipocontratoPage.vue?vue&type=script&lang=js"
export * from "./AddTipocontratoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports